import { NgClass, NgOptimizedImage } from '@angular/common';
import {
  booleanAttribute,
  Component,
  inject,
  input,
  resource,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ProfileService } from '../../core/data/profile/profile.service';

@Component({
  selector: 'app-nav-bar',
  imports: [NgClass, NgOptimizedImage, RouterLink],
  template: `
    <div
      class="px-4 py-4 md:py-4 bg-white/95 backdrop-blur transition-shadow"
      [ngClass]="
        border()
          ? 'border-b border-slate-200 shadow-sm'
          : 'border-0 shadow-none'
      "
    >
      <div class="mx-auto flex max-w-[1440px] items-center justify-between">
        <a routerLink="/">
          <img
            ngSrc="assets/mi_cable_go.png"
            height="42"
            width="150"
            alt="Logo Mi Cable GO"
          />
        </a>
        <div>
          <ng-content select="[right-content]"></ng-content>
        </div>
      </div>
    </div>
  `,
})
export class NavBarComponent {
  readonly #profileService = inject(ProfileService);

  profile = resource({
    loader: () => {
      return firstValueFrom(this.#profileService.getProfile());
    },
  });
  readonly border = input(true, { transform: booleanAttribute });
}
